module.exports = __webpack_public_path__ + "img/random.a5004bee.svg";